import { FormBuilder } from "../../../../../types/FormBuilderInterfaces";
import { Input, InputNumber, SelectPicker } from "rsuite";
import AppColorPicker from "../../../../../elements/AppColorPicker";
import { ColorPickerWrapper } from "./GeneralStyles";

interface Props {
  form: FormBuilder;
  setForm: (value: any, key: string) => void;
}

const buttonSizes: any = [
  {
    label: "Small",
    value: "Small",
  },
  {
    label: "Medium",
    value: "Medium",
  },
  {
    label: "Large",
    value: "Large",
  },
];

const buttonPositions: any = [
  {
    label: "Left",
    value: "Left",
  },
  { label: "Right", value: "Right" },
  { label: "Center", value: "Center" },
];

const ButtonStyles = ({ form, setForm }: Props) => {
  const handleSetForm = (value: any, key: string, secondOrderKey?: string) => {
    if (secondOrderKey) {
      return setForm(
        {
          ...form.ButtonStyles,
          //@ts-ignore
          [key]: { ...form.ButtonStyles?.[key], [secondOrderKey]: value },
        },
        "ButtonStyles"
      );
    }
    return setForm({ ...form.ButtonStyles, [key]: value }, "ButtonStyles");
  };

  return (
    <div className="d-flex flex-column">
      <div className="d-flex flex-column mb-3">
        <label className="text-sm font-weight-500 text-dark">Button Text</label>
        <Input
          value={form.ButtonStyles?.ButtonText}
          onChange={(value) => handleSetForm(value, "ButtonText")}
        />
      </div>
      <div className="d-flex flex-column mb-3">
        <label className="text-sm font-weight-500 text-dark">
          Border Radius (px)
        </label>
        <InputNumber
          value={form.ButtonStyles?.BorderRadius}
          placeholder="680"
          size="sm"
          className="mb-3"
          onChange={(value) => handleSetForm(value, "BorderRadius")}
        />
      </div>
      <ColorPickerWrapper title="Background Color">
        <AppColorPicker
          value={form.ButtonStyles?.BackgroundColor || "#ffffff"}
          onChange={(value) => handleSetForm(value, "BackgroundColor")}
          onClear={() => handleSetForm("#26B058", "BackgroundColor")}
        />
      </ColorPickerWrapper>
      <ColorPickerWrapper title="Text Color">
        <AppColorPicker
          value={form.ButtonStyles?.TextColor || "#ffffff"}
          onChange={(value) => handleSetForm(value, "TextColor")}
          onClear={() => handleSetForm("#ffffff", "TextColor")}
        />
      </ColorPickerWrapper>
      <div className="d-flex flex-column mb-3">
        <label className="text-sm font-weight-500 text-dark">Size</label>
        <SelectPicker
          searchable={false}
          data={buttonSizes}
          value={form.ButtonStyles?.Size}
          onChange={(value) => handleSetForm(value, "Size")}
        />
      </div>
      <div className="d-flex flex-column mb-3">
        <label className="text-sm font-weight-500 text-dark">Position</label>
        <SelectPicker
          preventOverflow
          searchable={false}
          data={buttonPositions}
          value={form.ButtonStyles?.Position}
          onChange={(value) => handleSetForm(value, "Position")}
        />
      </div>
    </div>
  );
};

export default ButtonStyles;
